var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlaying = function SvgPlaying(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#6ECE97",
    cx: 9.5,
    cy: 9.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9.502c0 .22-.691.703-1.64 1.243l-.54.298-.575.302-.595.298-.599.287-.587.268-.56.242c-.18.075-.353.145-.516.208l-.458.166c-.564.191-.93.252-.93.102V6.088c0-.211.691-.022 1.64.36l.54.225.284.125.587.268.599.288.595.3.575.302.276.15.516.296c.817.481 1.388.9 1.388 1.1z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgPlaying;